import { Report3 } from "../../components/report";

export default function ReportData3() {
  return <Report3 />;
}
